import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function customSeoBlock() {
  const widgetName = 'customSeoBlock';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof customSeoBlockOpts === 'undefined' ? null : customSeoBlockOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
      } else {
        $('.customSeoBlock-container').remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL, PurchaseURL } = widgetData[0];

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>`);

    if (URL != null || PurchaseURL != null) {
      $widget.append(`
        <div class="buttons-container">
          ${URL == null ? '' : `<a href="${URL}" class="button alternative-btn" ${updateLinksAttributes(URL, Title)}>More</a>`}
          ${PurchaseURL == null ? '' : `<a href="${PurchaseURL}" class="button alternative-btn" ${updateLinksAttributes(PurchaseURL, Title)}>Explore</a>`}
        </div>
          `);
    }
  }
}
